const KidItemStyle = theme => ({
    cardchild: {
        borderRadius: "15px",
        overflow: "hidden",
        border: "none",
        boxShadow: "0 0 20px rgba(0,0,0,0.15)",
        margin:"10px",
    },
    fab: {

    },
    media: {},
    root: {
    },
    icon: {},
});

export default KidItemStyle;
